import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const LandingCarrusel = ({ producto, initial = [] }) => {
  const [items, setItems] = useState(initial);

  useEffect(() => {
    axios.get(`${API}/api/landing/carrusel/${producto}`)
      .then((r) => { if (r.data?.items?.length) setItems(r.data.items); })
      .catch(() => {});
  }, [producto]);

  return (
    <div className="flex gap-4 overflow-x-auto px-4 pb-3 snap-x snap-mandatory max-w-6xl mx-auto" style={{ scrollbarWidth: 'thin' }} data-testid={`carrusel-strip-${producto}`}>
      {items.map((it, i) => (
        <figure key={it.id || `${i}-${it.caption}`} className="relative shrink-0 w-64 sm:w-72 snap-start rounded-2xl overflow-hidden border border-white/10 group bg-black/40">
          {it.tipo === 'video' ? (
            <video src={it.url} className="w-full h-80 object-cover" controls muted playsInline preload="metadata" data-testid={`carrusel-video-${i}`} />
          ) : (
            <img src={it.url} alt={it.caption || 'Proyecto'} className={`w-full h-80 object-cover ${it.pos || 'object-center'} group-hover:scale-105 transition-transform duration-500`} loading="lazy" />
          )}
          {it.caption ? (
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/90 to-transparent text-xs text-white/90 px-3 pt-10 pb-2 font-bold pointer-events-none">{it.caption}</figcaption>
          ) : null}
        </figure>
      ))}
    </div>
  );
};
